<div class="t-widget--noBottomPad">
  <header class="l-flex-column l-align-top">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.deliveryOrdersStatusSummaryTitle" | translate }}
    </h2>
    <hr />
  </header>

  <div class="content">
    <p *ngIf="data.openDeliveryOrdersCnt == 0">
      {{ "translate.dashboard.noOpenOrder" | translate }}
    </p>

    <p *ngIf="data.openDeliveryOrdersCnt > 0 && data.openDeliveryOrderDate">
      {{ getOpenOrderDateLbl(data.openDeliveryOrderDate) }}
    </p>
  </div>

  <div class="box-buttons">
    <button (click)="goToDeliveryOrder()" class="t-button-outline">
      {{ "translate.dashboard.goToDeliveryOrder" | translate }}
    </button>
  </div>
</div>
